// hooks/useBluetoothAvailability.js
import React, { useState, useEffect } from "react";

export const useBluetoothAvailability = () => {
  const [isBluetoothAvailable, setIsBluetoothAvailable] = useState(false);

  useEffect(() => {
    setIsBluetoothAvailable(!!navigator.bluetooth);
  }, []);

  return { isBluetoothAvailable };
};
